module.exports = __webpack_public_path__ + "img/REVOLUTION__1_-removebg-preview.f7d39f3b.png";